# Generated from app.intent.md — do not edit manually
# Route: /materials/definitions
# Audience: MES Engineers (md+), blocked on sm
# Ref: app.intent.md § Material Definitions

page-def-list:
  type: Page
  archetype: list
  meta:
    title: $t.def_list.meta_title
    auth: required
  data:
    definitions:
      model: ItemDefinition[]
      refresh: on_mount
    classes:
      model: ItemClass[]
      refresh: on_mount
    # F75 #139 (AC-P2) — controlled UoM vocabulary for the base-unit select.
    uom:
      model: UnitOfMeasure[]
      refresh: on_mount
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    padding: $spacing.lg
    padding_inline: $spacing.xl
    overflow: auto
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - def-list-sm-notice
    - def-list-content

# ── sm viewport notice ───────────────────────────────────────────────────────

def-list-sm-notice:
  type: SmNotice
  content: $t.common.sm_notice_def

# ── Main content (hidden on sm) ──────────────────────────────────────────────

def-list-content:
  type: Section
  spatial:
    display: flex
    direction: column
    gap: $spacing.lg
    responsive:
      sm:
        display: none
  children:
    - def-list-header
    - def-list-filter
    - def-list-table

# ── Header ───────────────────────────────────────────────────────────────────

def-list-header:
  type: PageHeader
  content: $t.def_list.title
  actions:
    - label: $t.def_list.btn_create
      route: /materials/definitions/new
      color: info
      # F79 — Cancel / on_success on the create screen returns to this list.
      return_context: origin_only

# ── Filter ───────────────────────────────────────────────────────────────────

def-list-filter:
  type: Section
  spatial:
    display: flex
    gap: $spacing.md
    align: center
  children:
    - def-list-filter-class
    - def-list-filter-clear

def-list-filter-class:
  type: Input
  input_type: select
  label: $t.def_list.filter_class
  a11y:
    label: $t.def_list.filter_class_label
  bind:
    options: classes
  spatial:
    min_height: touch-safe
    max_width: 16rem
  tokens:
    border: $border.default
    radius: $radius.md
    font_size: $font.size.sm

def-list-filter-clear:
  type: Button
  variant: ghost
  content: $t.common.filter_clear
  a11y:
    label: $t.common.filter_clear_label
  action:
    type: custom
  spatial:
    min_height: $size.touch-target
    padding_inline: $spacing.md

# ── Definition table ─────────────────────────────────────────────────────────

def-list-table:
  type: Table
  bind:
    rows: definitions
  empty: def-list-empty
  columns:
    - key: name
      label: $t.def_list.col_name
      tokens:
        font_size: $font.size.sm
    - key: itemClassId
      label: $t.def_list.col_class
      tokens:
        font_size: $font.size.sm
    - key: trackingMode
      label: $t.def_list.col_tracking
      tokens:
        font_size: $font.size.sm
    - key: baseUnitOfMeasure
      priority: medium
      label: $t.def_list.col_unit
      tokens:
        font_size: $font.size.sm
    - key: shelfLifeDays
      priority: low
      label: $t.def_list.col_shelf_life
      tokens:
        font_family: $font.family.mono
        font_size: $font.size.sm
    - key: makeOrBuy
      label: $t.def_list.col_make_buy
      tokens:
        font_size: $font.size.sm
  # F75 #134 (AC-C3) — row click navigates to the read-only definition detail page.
  row_action:
    type: navigate
    route: /materials/definitions/:id
    params:
      id: $row.id
  a11y:
    label: $t.def_list.table_label
  spatial:
    width: 100%
  tokens:
    border: $border.default
    radius: $radius.md
    background: $color_scheme.light.color.surface-elevated

def-list-empty:
  type: EmptyState
  content: $t.def_list.empty
  body: $t.def_list.empty_body
  tokens:
    color: $color_scheme.light.color.on-surface-muted
    font_size: $font.size.md
  spatial:
    padding: $spacing.lg
